import dynamic from "next/dynamic";
import { useMemo, type ComponentType, type FC } from "react";
import { VARIANT } from "@/constant";
type Props = {
  isOPen: boolean;
  handleClose: () => void;
  TEST_VARIANT: VARIANT;
};
function dynamicImportFromVariant(variant: VARIANT): ComponentType<Props> {
  return dynamic(() => import(`./variants/${variant}`), {
    ssr: false
  });
}
const SignupModalContainer: FC<Props> = props => {
  const {
    TEST_VARIANT
  } = props;
  const variants: Record<VARIANT, ComponentType<Props>> = {
    A: dynamicImportFromVariant(VARIANT.VariantA),
    B: dynamicImportFromVariant(VARIANT.VariantB),
    C: dynamicImportFromVariant(VARIANT.VariantC),
    D: dynamicImportFromVariant(VARIANT.VariantD),
    E: dynamicImportFromVariant(VARIANT.VariantE)
  };
  const SignupModal = useMemo(() => variants[TEST_VARIANT], [TEST_VARIANT]);
  return <SignupModal {...props} data-sentry-element="SignupModal" data-sentry-component="SignupModalContainer" data-sentry-source-file="SignupModalContainer.tsx" />;
};
export default SignupModalContainer;